"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagSZ = function FlagSZ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,96.93H216.6V139.3a7.07,7.07,0,0,1-7.06,7.06H-185.94A7.07,7.07,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v42.37H-193v-42.37a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "50.43",
    width: "409.6",
    height: "169.49",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "43.37",
    width: "409.6",
    height: "14.13",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "212.86",
    width: "409.6",
    height: "14.12",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M166.12,19H-142.81a3.8,3.8,0,0,1-3.8-3.8V14a3.8,3.8,0,0,1,3.8-3.8H166.12a3.8,3.8,0,0,1,3.79,3.8v1.2a3.8,3.8,0,0,1-3.79,3.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M106.17,1.41l15.38-6.59,15.39,6.59L121.55,8Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110-1.4h-225.8a2.81,2.81,0,0,0-2.81,2.81,2.81,2.81,0,0,0,2.81,2.81H110a2.81,2.81,0,1,0,0-5.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M122.17-14l15.38-6.59L152.94-14l-15.39,6.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M126-16.79H-99.84A2.81,2.81,0,0,0-102.65-14a2.81,2.81,0,0,0,2.81,2.81H126A2.81,2.81,0,0,0,128.76-14,2.81,2.81,0,0,0,126-16.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.65-42.55c-39,0-73.11,22.11-91.35,55,18.24,32.84,52.3,55,91.35,55S84.77,45.24,103,12.4C84.77-20.44,50.7-42.55,11.65-42.55Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-79.7,12.4c18.24,32.84,52.3,55,91.35,55A101.76,101.76,0,0,0,30.73,65.5C26,55.12,9.38,55.14,8.35,51.23,7.26,47,21.91,47.94,24.48,44.46S10.55,39.51,9.82,36s6.6-5.86,7.88-11.36,4.21-7.14,6.41-10.44S20.45,9.84,19-1.15,8.91-13.61,4.7-22.59s2.56-15.56,7-20c-39.06,0-73.12,22.11-91.36,55Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "148.5",
    y: "115.62",
    width: "4.4",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "157.3",
    y: "115.62",
    width: "4.39",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "166.09",
    y: "115.62",
    width: "4.4",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "174.88",
    y: "115.62",
    width: "4.4",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "183.67",
    y: "115.62",
    width: "4.39",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "192.46",
    y: "115.62",
    width: "4.39",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "148.5",
    y: "142",
    width: "4.4",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "157.3",
    y: "142",
    width: "4.39",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "166.09",
    y: "142",
    width: "4.4",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "174.88",
    y: "142",
    width: "4.4",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "183.67",
    y: "142",
    width: "4.39",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "192.46",
    y: "142",
    width: "4.39",
    height: "17.58",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "214.44",
    y: "115.62",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "223.23",
    y: "115.62",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "232.02",
    y: "115.62",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "240.82",
    y: "115.62",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "249.61",
    y: "115.62",
    width: "4.39",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "258.4",
    y: "115.62",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "214.44",
    y: "142",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "223.23",
    y: "142",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "232.02",
    y: "142",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "240.82",
    y: "142",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "249.61",
    y: "142",
    width: "4.39",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "258.4",
    y: "142",
    width: "4.4",
    height: "17.58",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M147.31,9.51c-3.52,8.19-13.54,9.15-8,30l2.84-2.88a32.59,32.59,0,0,0,10.16,13.15s8.8-7.38,9.48-19.09l3.65,1.61S163.69,11,147.31,9.51Zm0,0",
    transform: "translate(194 123)",
    fill: "#245dbd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M160.3,26.27a1,1,0,0,1-.77-.38,18.09,18.09,0,0,0-7.88-5.51,1.31,1.31,0,0,1-.79-1.55,1.08,1.08,0,0,1,1.31-.94,20.12,20.12,0,0,1,8.91,6.2,1.47,1.47,0,0,1,0,1.82,1,1,0,0,1-.77.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M157.82,36a1.05,1.05,0,0,1-.86-.51,25,25,0,0,0-5.48-6.1,1.44,1.44,0,0,1-.36-1.77,1,1,0,0,1,1.5-.41,27,27,0,0,1,6.06,6.72,1.43,1.43,0,0,1-.2,1.8,1,1,0,0,1-.66.27Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M152.14,46.77a.65.65,0,0,1-.19,0,1.27,1.27,0,0,1-.88-1.47A33.8,33.8,0,0,0,150.55,35a1.35,1.35,0,0,1,.75-1.59,1.08,1.08,0,0,1,1.34.9,36.91,36.91,0,0,1,.56,11.36,1.14,1.14,0,0,1-1.06,1.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M144.52,34.93a1,1,0,0,1-.83-.46,1.47,1.47,0,0,1,.13-1.81A14.36,14.36,0,0,0,147.34,26a1.09,1.09,0,0,1,1.29-1,1.3,1.3,0,0,1,.82,1.53,16.88,16.88,0,0,1-4.23,8.13,1,1,0,0,1-.7.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M141.52,26.72a1.06,1.06,0,0,1-.93-.62,1.43,1.43,0,0,1,.36-1.76s4-2.92,5.18-6.08a1,1,0,0,1,1.44-.63,1.41,1.41,0,0,1,.54,1.7c-1.5,3.87-5.85,7.06-6,7.2a1,1,0,0,1-.56.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-127.17,12.26c-2.94,6.84-11.32,7.65-6.68,25.08l2.38-2.41a27.3,27.3,0,0,0,8.49,11s7.35-6.17,7.92-16l3.06,1.34s-1.47-17.83-15.17-19Zm0,0",
    transform: "translate(194 123)",
    fill: "#245dbd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-116.31,26.28a.85.85,0,0,1-.64-.32,15.29,15.29,0,0,0-6.59-4.61,1.1,1.1,0,0,1-.66-1.3.91.91,0,0,1,1.09-.78,16.71,16.71,0,0,1,7.45,5.19,1.2,1.2,0,0,1,0,1.51.81.81,0,0,1-.64.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.38,34.39a.86.86,0,0,1-.72-.42,20.81,20.81,0,0,0-4.59-5.1,1.21,1.21,0,0,1-.29-1.48.83.83,0,0,1,1.25-.35,23.28,23.28,0,0,1,5.07,5.63,1.21,1.21,0,0,1-.17,1.5.8.8,0,0,1-.55.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-123.13,43.43l-.16,0a1.08,1.08,0,0,1-.74-1.24,28.35,28.35,0,0,0-.43-8.56,1.11,1.11,0,0,1,.63-1.32.88.88,0,0,1,1.11.74,30.93,30.93,0,0,1,.48,9.5,1,1,0,0,1-.89.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-129.5,33.52a.87.87,0,0,1-.7-.38,1.23,1.23,0,0,1,.11-1.52A12,12,0,0,0-127.15,26a.92.92,0,0,1,1.08-.82,1.1,1.1,0,0,1,.69,1.28,14.13,14.13,0,0,1-3.54,6.79.83.83,0,0,1-.58.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-132,26.65a.88.88,0,0,1-.77-.51,1.18,1.18,0,0,1,.3-1.47s3.31-2.45,4.33-5.08a.86.86,0,0,1,1.21-.54,1.17,1.17,0,0,1,.44,1.42c-1.25,3.24-4.88,5.91-5,6a.84.84,0,0,1-.48.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagSZ;
exports["default"] = _default;